






































































import Vue from 'vue'
import {mapState} from "vuex";
export default  Vue.extend({
    name: "Sidebar",
    data:() => ({
        innerValue:false,
        items: [
            { icon: 'fa-tachometer-alt', text: 'Dashboard', to: '/',  roles: ['ADMIN', 'EDITOR'] },
            { icon: 'fa-tachometer-alt', text: 'Jane', to: '/',  roles: ['USER'] },
            { icon: 'fa-users', text: 'Users', to: '/usuarios', roles: ['ADMIN'] },
            { icon: 'subscriptions', text: 'Lessons', to: '/clases', roles: ['ADMIN', 'EDITOR'] },
            { icon: 'subscriptions', text: 'My lessons', to: '/myClass', roles: ['USER'] },
            { icon: 'history', text: 'Record', to: '/hitorial' , roles: ['ADMIN']},
            { icon: 'fa-list', text: 'Categories', to: '/categorias', roles: ['ADMIN', 'EDITOR'] },
            { icon: 'fa-list', text: 'Subcategories', to: '/subcategorias', roles: ['ADMIN', 'EDITOR'] },
            { icon: 'featured_play_list', text: 'Practices', to: '/practicas', roles: ['ADMIN', 'EDITOR'] },
            { icon: 'image', text: 'Pictionary-Admin', to: '/pictionary-admin', roles: ['ADMIN', 'EDITOR'] },
            { icon: 'image', text: 'Pictionary', to: '/pictionary', roles: ['USER'] },
            { icon: 'fa-video', text: 'Video', to: '/video', roles: ['ADMIN', 'EDITOR'] },
            { icon: 'fa-video', text: 'Videos', to: '/video-practica', roles: ['USER'] },
            //{ icon: 'fa-video', text: 'Musicals', to: '/musical-practica', roles: ['USER'] },
            { icon: 'fa-gamepad', text: 'Games', to: '/admin-juegos', roles: ['ADMIN', 'EDITOR'] },
            { icon: 'fa-gamepad', text: 'alphabet soup', to: '/juegos/sopa-letras', roles: ['USER'] },
            { icon: 'fa-gamepad', text: 'Crosswords', to: '/juegos/crucigrama', roles: ['USER'] },
            { icon: 'featured_play_list', text: 'Levels', to: '/niveles', roles: ['ADMIN'] },
        ]
    }),
    props:['value'],
    watch: {
        // Handles internal model changes.
        innerValue (newVal) {
            this.$emit('input', newVal);
        },
        // Handles external model changes.
        value (newVal) {
            this.innerValue = newVal;
        }
    },
    methods:{
        salir(){
            this.$store.dispatch('logout');

        }
    },
    computed:{
        getItemsSidebar(){
            return this.items.filter((e: any) => {
                return e.roles.includes(this.fullUser.role)
            });
        },


        getAvatar(){
            return this.avatars.filter((e: any) => {
               return  e.gender == this.fullUser.gender && e.level == this.userDetails.lastClass
            })
        },



        getAllAvatar(){
            return this.avatars.filter((e: any) => {
                return  e.gender == this.fullUser.gender
            })
        },
        ...mapState({
            fullUser:(state: any) => state.auth.fullUser,
            userDetails: (state: any) => state.user.userDetails,
            avatars: (state: any) => state.avatar.avatars
        })
    }


})
